import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { Box, Container } from "@material-ui/core";

import { trackPageView } from "@ip-utils";

import ErrorBoundary from "./ErrorBoundary";
import Footer from "./Footer";
import Header from "./Header";
import VersionCheck from "./VersionCheck";

type MaUIWithNavbarLayoutProps = {
  children: React.ReactNode;
};

export default function MaUIWithNavbarLayout({
  children,
}: MaUIWithNavbarLayoutProps) {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  const padding = [2, 3];
  return (
    <ErrorBoundary>
      <Box display="flex" flexDirection="column" minHeight="100vh">
        <VersionCheck />
        <Box display="flex" flexDirection="column" minHeight="100vh">
          <Header />
          <Box
            bgcolor="common.background"
            flexGrow={1}
            paddingBottom={padding}
            paddingTop={padding}
          >
            <Container maxWidth="lg">
              <div>{children}</div>
            </Container>
          </Box>
          <Footer />
        </Box>
      </Box>
    </ErrorBoundary>
  );
}
